import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-datepicker/dist/react-datepicker.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { enableorDisableFeaturesFromUrl } from './Utils/features';
import { initializeAppInsights, overrideConsoleError } from './Utils/appInsights';

enableorDisableFeaturesFromUrl();
initializeAppInsights();
overrideConsoleError();

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
	<BrowserRouter>
		<MsalProvider instance={msalInstance}>
			<App />
		</MsalProvider>
	</BrowserRouter>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
